import React, { useState } from 'react';
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaGithub } from 'react-icons/fa';
import globeImage from '../assets/hii.gif'; // Import the local image

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Message from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`);
    window.location.href = `mailto:keshriabhay57@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contact">
      <style>
        {`
          .contact-section {
           
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            padding: 20px;
            overflowing: hidden;
            animation: fadeIn 1.5s ease-in-out;
            font-family: 'Arial', sans-serif;
          }
          .contact-section::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(${globeImage}) no-repeat center center; /* Use imported image */
            background-size: cover;
            opacity: 0.3;
            z-index: 0;
          }
          .contact-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            max-width: 1200px;
            padding: 40px;
            gap: 40px;
            position: relative;
            z-index: 1;
          }
          .form-container {
            background: rgba(17, 14, 25, 0.9);
            padding: 40px;
            border-radius: 20px;
            width: 100%;
            max-width: 500px;
            transform: translateY(50px);
            opacity: 0;
            animation: slideIn 0.8s ease-out forwards;
            animation-delay: 0.2s;
          }
          .form-container h2 {
            font-size: 4rem;
            font-weight: 700;
            color: #ffffff;
            margin-bottom: 10px;
          }
          .form-container h3 {
            font-size: 1.2rem;
            font-weight: 400;
            color: #a0a0ff;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 30px;
          }
          .form-group {
            margin-bottom: 20px;
          }
          .form-group label {
            display: block;
            font-size: 1.1rem;
            color: #ffffff;
            margin-bottom: 5px;
          }
          .form-group input,
          .form-group textarea {
            width: 100%;
            padding: 12px 12px;
            background: rgba(60, 60, 90, 0.8);
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 50px;
            color: #ffffff;
            font-size: 1rem;
            transition: all 0.4s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }
          .form-group input:focus,
          .form-group textarea:focus {
            background: rgba(80, 80, 110, 0.9);
            border-color: #a0a0ff;
            box-shadow: 0 6px 20px rgba(160, 160, 255, 0.3);
            outline: none;
          }
          .form-group input::placeholder,
          .form-group textarea::placeholder {
            color: #a0a0ff;
            opacity: 0.7;
          }
          .form-group textarea {
            border-radius: 25px;
            min-height: 120px;
            resize: vertical;
          }
          .submit-button {
            display: block;
            width: 100%;
            padding: 14px;
            background: linear-gradient(90deg, #a0a0ff, #6b6bff);
            border: none;
            border-radius: 50px;
            color: #ffffff;
            font-size: 1.1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.4s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
            text-align: center;
          }
          .submit-button:hover {
            background: linear-gradient(90deg, #6b6bff, #a0a0ff);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(160, 160, 255, 0.4);
          }
          .globe-image {
            width: 500px;
            height: 500px;
            background: url(${globeImage}) no-repeat center;
            background-size: contain;
            animation: float 6s ease-in-out infinite;
            opacity: 0;
            animation-delay: 0.4s;
            animation-fill-mode: forwards;
          }
          .social-icons {
            position: fixed;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            gap: 20px;
            z-index: 1;
          }
          .social-icon {
            width: 50px;
            height: 50px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 1.5rem;
            transition: all 0.3s ease;
            transform: translateX(20px);
            opacity: 0;
            animation: slideInRight 0.5s ease-out forwards;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }
          .social-icon:nth-child(1) { animation-delay: 0.4s; }
          .social-icon:nth-child(2) { animation-delay: 0.5s; }
          .social-icon:nth-child(3) { animation-delay: 0.6s; }
          .social-icon:nth-child(4) { animation-delay: 0.7s; }
          .social-icon:hover {
            background: #a0a0ff;
            color: #1a1a1a;
            transform: scale(1.1) translateX(0);
            box-shadow: 0 6px 20px rgba(160, 160, 255, 0.4);
          }

          /* Animations */
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideIn {
            from { opacity: 0; transform: translateY(50px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes slideInRight {
            from { opacity: 0; transform: translateX(20px); }
            to { opacity: 1; transform: translateX(0); }
          }
          @keyframes float {
            0% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0); }
          }

          /* Mobile Responsiveness */
          @media (max-width: 1024px) {
            .contact-container {
              flex-direction: column;
              padding: 20px;
              gap: 30px;
            }
            .form-container {
              max-width: 100%;
              padding: 30px;
            }
            .form-container h2 {
              font-size: 3rem;
            }
            .form-container h3 {
              font-size: 1rem;
            }
            .globe-image {
              width: 400px;
              height: 400px;
            }
            .social-icons {
              position: static;
              transform: none;
              flex-direction: row;
              justify-content: center;
              margin-top: 30px;
              width: 100%;
              order: 2;
            }
            .social-icon {
              width: 40px;
              height: 40px;
              font-size: 1.2rem;
            }
          }

          @media (max-width: 768px) {
            .contact-section {
              padding: 15px;
            }
            .contact-container {
              padding: 15px;
            }
            .form-container {
              padding: 20px;
            }
            .form-container h2 {
              font-size: 2.5rem;
            }
            .form-container h3 {
              font-size: 0.9rem;
              margin-bottom: 20px;
            }
            .form-group label {
              font-size: 1rem;
            }
            .form-group input,
            .form-group textarea {
              padding: 10px 20px;
              font-size: 0.9rem;
            }
            .form-group textarea {
              min-height: 100px;
            }
            .submit-button {
              padding: 12px;
              font-size: 1rem;
            }
            .globe-image {
              width: 300px;
              height: 300px;
            }
            .social-icons {
              margin-top: 20px;
            }
            .social-icon {
              width: 40px;
              height: 40px;
              font-size: 1.2rem;
            }
          }

          @media (max-width: 480px) {
            .form-container h2 {
              font-size: 2rem;
            }
            .form-container h3 {
              font-size: 0.8rem;
            }
            .form-group label {
              font-size: 0.9rem;
            }
            .form-group input,
            .form-group textarea {
              padding: 8px 8px;
              font-size: 0.8rem;
            }
            .submit-button {
              padding: 10px;
              font-size: 0.9rem;
            }
            .globe-image {
              width: 250px;
              height: 250px;
            }
            .social-icons {
              margin-top: 15px;
            }
            .social-icon {
              width: 35px;
              height: 35px;
              font-size: 1rem;
            }
          }
        `}
      </style>
      <div className="contact-section">
      <div className="contact-container">
        <div className="form-container">
          <h3>GET IN TOUCH</h3>
          <h2>Contact.</h2>
          <div>
            <div className="form-group">
              <label>Your Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="What's your good name?"
                required
              />
            </div>
            <div className="form-group">
              <label>Your Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="What's your web address?"
                required
              />
            </div>
            <div className="form-group">
              <label>Your Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="What you want to say?"
                required
              ></textarea>
            </div>
            <button onClick={handleSubmit} className="submit-button">Send Message</button>
          </div>
        </div>
        <div className="globe-image"></div>
      </div>
      <div className="social-icons">
        <a
          href="https://www.instagram.com/_keshri.abhay_/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.facebook.com/itsabhay57"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="Facebook"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://www.linkedin.com/in/abhay-keshri-857386323/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="LinkedIn"
        >
          <FaLinkedinIn />
        </a>
        <a
          href="https://github.com/Abhaykeshri"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="GitHub"
        >
          <FaGithub />
        </a>
      </div>
      </div>
    </section>
  );
};

export default Contact;